import { QRCodeCanvas } from "qrcode.react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "./ui/dialog";
import { Download, Copy, MessageCircle } from "lucide-react";
import { toast } from "sonner";
import { downloadPDF } from "../lib/pdf";

export default function ShareQRDialog({ doc, onClose }) {
  const shareUrl = doc ? `${window.location.origin}/receta/${doc.share_id}` : "";
  return (
    <Dialog open={!!doc} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="rounded-3xl max-w-sm" data-testid="share-qr-dialog">
        <DialogHeader><DialogTitle className="font-outfit text-brand-ink">Compartir por QR</DialogTitle></DialogHeader>
        {doc && (
          <div className="flex flex-col items-center gap-4 mt-2">
            <div className="bg-white p-4 rounded-2xl border border-stone-200"><QRCodeCanvas value={shareUrl} size={190} fgColor="#1E293B" level="M" /></div>
            <p className="text-xs text-muted-foreground text-center break-all">{shareUrl}</p>
            <div className="flex gap-2 w-full">
              <button data-testid="share-qr-copy" onClick={() => { navigator.clipboard.writeText(shareUrl); toast.success("Enlace copiado"); }}
                className="flex-1 bg-muted text-brand-ink font-semibold py-2.5 rounded-xl text-sm flex items-center justify-center gap-1.5"><Copy size={15} /> Copiar</button>
              <button data-testid="share-qr-pdf" onClick={() => downloadPDF(doc, shareUrl)}
                className="flex-1 bg-brand-terracotta text-white font-semibold py-2.5 rounded-xl text-sm flex items-center justify-center gap-1.5"><Download size={15} /> PDF</button>
            </div>
            <a data-testid="share-qr-whatsapp" href={`https://wa.me/?text=${encodeURIComponent(shareUrl)}`} target="_blank" rel="noopener noreferrer"
              className="w-full text-center bg-brand-sage text-white font-semibold py-2.5 rounded-xl text-sm flex items-center justify-center gap-1.5"><MessageCircle size={15} /> Enviar por WhatsApp</a>
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
}
